import { ResultType, TTournamentParams, Warrior } from '~/../api/common.types';
import { TOURNAMENTS } from '~/constants';

export default function BattleChronicle({ warrior, tournamentParam }: { warrior: Warrior, tournamentParam: TTournamentParams }) {
  const tournamentType = TOURNAMENTS[tournamentParam];
  const contextId = tournamentType?.apiContext;
  const contextChronicle = warrior.warrior_json.context_chronicles[contextId];

  if (!contextChronicle) {
    return <></>;
  }
  const contextChronicleSorted = contextChronicle.sort(
    (a, b) => a.state > b.state
  );
  const lastChronicle =
    contextChronicleSorted[contextChronicleSorted.length - 1] as ResultType;

  const lastAttack =
    lastChronicle.entries.find(
      (entry) => {
        return entry.warrior.id == warrior.warrior_id;
      }
    )?.current_attack || '';
  // const { victor } = lastChronicle;
  // let outcome = '';
  // if (victor === warrior.warrior_id) outcome = 'won';
  // if (victor !== undefined && victor !== warrior.warrior_id) outcome = 'lost';
  // if (victor === undefined) outcome = 'tied';

  if (lastAttack) {
    return (
      <div className="battle-chronicle__entry">
        Previously threw{' '}
        <span className="battle-chronicle__attack" data-id={lastAttack}>
          <img
            src={`/img/syndicate.${lastAttack.toLowerCase()}.png`}
            alt={lastAttack}
          />
          {lastAttack}
        </span>

      </div>
    );
  }
  return (
    <div className="battle-chronicle__entry">
      Previously did not throw an attack
    </div>
  );
}
